<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nic6pI/tc-custom/9781576335383.jpg?1728724893935" alt="This image is the cover for the book TEAS 6 Test Prep Algebra Review--Exambusters Flash Cards--Workbook 2 of 5, Exambusters TEAS 6"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">TEAS 6 Test Prep Algebra Review--Exambusters Flash Cards--Workbook 2 of 5, Exambusters TEAS 6
      </h1>
      <p class="bookDescription body article font2">
        <p>"TEAS 6 Prep Flashcard Workbook 2: ALGEBRA REVIEW" 450 questions and answers that highlight introductory algebra definitions, problems, and concepts. Topics: Algebraic Concepts, Sets, Variables, Exponents, Properties of Numbers, Simple Equations, Signed Numbers, Monomials, Polynomials, Additive and Multiplicative Inverse, Word Problems, Prime Numbers, Factoring, Algebraic Fractions, Ratio and Proportion, Variation, Radicals, Quadratic Equations ==================================== ADDITIONAL WORKBOOKS: "TEAS V Prep Flashcard Workbook 3: BIOLOGY REVIEW" 450 questions and answers (ILLUSTRATED). Essential definitions and concepts. Topics: Cells, Biochemistry and Energy, Evolution and Classification, Kingdoms: Bacteria, Fungi, Protista; Kingdom: Plantae, Kingdom: Animalia, Human Locomotion, Human Circulation and Immunology, Human Respiration and Excretion, Human Digestion, Human Nervous System, Human Endocrinology, Reproduction and Development, Genetics, Ecology _______________ "TEAS V Prep Flashcard Workbook 5: VOCABULARY REVIEW" 350 frequently tested words every college graduate should know. Perfect for anyone who wants to enrich their vocabulary! Improve your reading comprehension and conversation. Includes sample sentence, part of speech, pronunciation, succinct, easy-to-remember definition, and common synonyms and antonyms. ==================================== "Exambusters TEAS V Prep Workbooks" provide comprehensive, fundamental TEAS V review--one fact at a time--to prepare students to take practice TEAS V tests. Each TEAS V study guide focuses on one specific subject area covered on the TEAS V exams. From 300 to 600 questions and answers, each volume in the TEAS V series is a quick and easy, focused read. Reviewing TEAS V flash cards is the first step toward more confident TEAS V preparation and ultimately, higher TEAS V exam scores!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        TEAS  6 Exambusters
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Cram Now!
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e1eb166